import { render, staticRenderFns } from "./DevolucaoMedico.vue?vue&type=template&id=1017e4d8&"
import script from "./DevolucaoMedico.vue?vue&type=script&lang=js&"
export * from "./DevolucaoMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports